import React from 'react';
import { Route, withRouter } from 'react-router';

import ModalRoot from './modal/ModalRoot';
import BannerRoot from './banner/BannerRoot';
import HeadComponent from './HeadComponent';
import SkipLink from './rgaa/SkipLink';
import RouteAnnouncer from './rgaa/RouteAnnouncer';
import SessionTimeoutWarning from './rgaa/SessionTimeoutWarning';
import RouterComponent from './router/RouterComponent';
import ScrollToTopComponent from './ScrollToTopComponent';

class App extends React.Component {
    render() {
        return (
            <div id="app">
                <SkipLink />
                <RouteAnnouncer />
                <HeadComponent />
                <Route component={RouterComponent} />
                <ModalRoot />
                <BannerRoot />
                <ScrollToTopComponent />
                <SessionTimeoutWarning />
            </div>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js